import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import SeoData from "./seo-list.json";
import { useHistory } from "react-router-dom";

const schemaData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Sphoorti Machine Tools Pvt. Ltd.",
  url: "https://www.sphoorti.com/",
  logo: "https://www.sphoorti.com/static/media/logo.17eb81d7427521fb920f.png",
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+91 8041272768",
    contactType: "sales",
    areaServed: "IN",
    availableLanguage: "en",
  },
  sameAs: [
    "https://www.facebook.com/SphoortiMachineToolsPvtLtd",
    "https://www.instagram.com/sphoorti_machine_tools",
    "https://www.linkedin.com/company/sphoortimachinetools",
    "https://www.youtube.com/your-channel-url", // Use your real YouTube URL
    "https://www.sphoorti.com/",
    "https://x.com/sphoorti_tools",
  ],
};

const schemaData2 = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "Sphoorti Machine Tools Pvt. Ltd.",
  image: "https://www.sphoorti.com/static/media/logo.17eb81d7427521fb920f.png",
  "@id": "https://www.sphoorti.com/",
  url: "https://www.sphoorti.com/",
  telephone: "+918041272768",
  address: {
    "@type": "PostalAddress",
    streetAddress:
      "#18, Plot No. 467-469, 12th Cross, 4th Phase, Peenya Industrial Area",
    addressLocality: "Bengaluru",
    postalCode: "560058",
    addressCountry: "IN",
  },
  sameAs: [
    "https://www.facebook.com/SphoortiMachineToolsPvtLtd",
    "https://x.com/sphoorti_tools",
    "https://www.instagram.com/sphoorti_machine_tools",
    "https://www.youtube.com/your-channel-url",
    "https://www.linkedin.com/company/sphoortimachinetools",
  ],
};

const schemaData3 = {
  "@context": "https://schema.org/",
  "@type": "WebSite",
  name: "Sphoorti Machine Tools Pvt. Ltd.",
  url: "https://www.sphoorti.com/",
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: "https://www.sphoorti.com/search?q={search_term_string}",
    },
    "query-input": {
      "@type": "PropertyValueSpecification",
      valueRequired: "http://schema.org/True",
      valueName: "search_term_string",
    },
  },
};

const SEO = () => {
  let { pathname, href: canonicalLink } = window.location;

  const [customSEODATA, setcustomSEODATA] = useState([]);

  const history = useHistory();
  useEffect(() => {
    console.log("SeoData=>", SeoData);

    // setcustomSEODATA(SeoData[0]);
    history.listen((location) => {
      let getSeoItem = SeoData?.filter(
        (item) => item?.pathname == location?.pathname
      );
      console.log("getSeoItem=>", getSeoItem);
      if (getSeoItem?.length > 0) {
        setcustomSEODATA(getSeoItem);
      } else {
        setcustomSEODATA([
          {
            title: "Top machine tool manufacturers in India Sphoorti ",
            description:
              "Sphoorti is a well-established machine tool manufacturer, managed and powered by a team of experienced engineers and professionals. We are one of the top machine tool manufacturers in India",
            keywords:
              "sphoorti machine tools, best machine tools, vdi tool holder, machine tool manufacturing, ",
          },
        ]);
        console.log("not found");
      }
    });
  }, [history?.location?.pathname]);
  // console.log("customSEODATA");
  // console.log(customSEODATA, "cccciiooo");
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{customSEODATA?.[0]?.title}</title>
        <meta
          property="og:title"
          content={
            `${customSEODATA?.[0]?.title}` ||
            "Tool Holders & Tool Discs Manufacturer in India | Sphoorti "
          }
        />
        <meta
          property="title"
          content={
            `${customSEODATA?.[0]?.title}` ||
            "Tool Holders & Tool Discs Manufacturer in India | Sphoorti "
          }
        />
        <meta
          name="og:description"
          content={`${
            customSEODATA?.[0]?.description
              ? customSEODATA?.[0]?.description
              : "Discover premium tool holders and tool discs from India's trusted manufacturer – Sphoorti. Global supply, top-quality CNC tooling solutions."
          }`}
        />
        <meta
          name="description"
          content={`${
            customSEODATA?.[0]?.description
              ? customSEODATA?.[0]?.description
              : "Discover premium tool holders and tool discs from India's trusted manufacturer – Sphoorti. Global supply, top-quality CNC tooling solutions."
          }`}
        />
        <meta name="keywords" content={customSEODATA?.[0]?.keywords} />

        <link rel="canonical" href={canonicalLink} />

        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
        <script type="application/ld+json">
          {JSON.stringify(schemaData2)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(schemaData3)}
        </script>
      </Helmet>
    </div>
  );
};

export default SEO;
